<h2 mat-dialog-title>{{'Registration' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <div class="example-container">
    <h3>{{'Crew registration' | translate}}</h3>
      <mat-form-field appearance="fill">
        <mat-label>{{'Crew number' | translate}}</mat-label>
        <mat-select [(value)]="crewNumber" [formControl]="crewNumberFieldControl">
          <mat-option *ngFor="let number of numbers"
                      value="{{number}}">
            {{number}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="crewNumberFieldControl.invalid">{{getErrorMessage(crewNumberFieldControl) | translate}}</mat-error>
      </mat-form-field>
    <p>
      <mat-form-field appearance="fill">
        <mat-label>{{'Driver' | translate}}</mat-label>
        <mat-select [formControl]="driverFieldControl">
          <mat-option *ngFor="let competitor of drivers"
                      value="{{competitor}}"
                      (click)="processDrivers(competitor)">
            {{competitor.firstName + ' ' + competitor.lastName}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="driverFieldControl.invalid">{{getErrorMessage(driverFieldControl) | translate}}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>{{'Navigator' | translate}}</mat-label>
        <mat-select [formControl]="navigatorFieldControl">
          <mat-option *ngFor="let competitor of navigators"
                      value="{{competitor}}"
                      (click)="processNavigators(competitor)">
            {{competitor.firstName + ' ' + competitor.lastName}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="navigatorFieldControl.invalid">{{getErrorMessage(navigatorFieldControl) | translate}}</mat-error>
      </mat-form-field>
    </p>
  </div>
</mat-dialog-content>
<mat-error *ngIf="serverIsDown">{{'Server problem, contact an administrator' | translate}}</mat-error>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'Cancel' | translate}}</button>
  <button mat-button
          [disabled]="allFieldsAreFilled()"
          (click)="onSaveCrew()">{{'Create crew' | translate}}</button>
</mat-dialog-actions>
